import { CF_CASH_FLOW, CF_CASH_FLOW_RESET, CF_CASH_PCG_ITEMS, CF_CASH_PCG_ITEMS_RESET, CF_CASH_STRUCTURE, CF_COINS, CF_COINS_LOADING, CF_COMPANIES, CF_PROJECTS_BY_COMPANY, CF_PROJECTS_BY_COMPANY_RESET, CF_CASH_RUBRO_ITEMS, CF_CASH_RESOURCE_ITEMS, CF_CASH_CDT_ITEMS, CF_COMPANIES_LOADING, CF_CASH_FLOW_GET_USER_FILTERS, CF_CASH_FLOW_SAVE_USER_FILTERS } from "../constants";
import { cleanDuplicates } from "../utils/data";
import { orderByPeriods } from "../utils/periodOrder";

const initialState = {
	coinsLoading: false,
	coins: [],
	companiesLoading: false,
	companies: [],
	projectsByCompanies: [],
	projectsByCompaniesParts: [],
	projectsByCompaniesLoading: true,
	cashFlowData: [],
	cashFlowDataParts: [],
	cashFlowDataLoading: false,
	cashFlowEstructure: [],
	cashFlowPcgItemsResume: [],
	userFilters: null
};
// eslint-disable-next-line
export default (state = initialState, {type, payload}) => {
	switch (type) {
		case CF_COINS:
			return {
				...state,
				coins: payload.data,
			};
		case CF_COINS_LOADING:
			return {
				...state,
				coinsLoading: true,
			};
		case CF_COMPANIES:
			return {
				...state,
				companies: payload.data,
			};
		case CF_COMPANIES_LOADING:
			return {
				...state,
				companiesLoading: true,
			};
		case CF_PROJECTS_BY_COMPANY:
			const projectsByCompaniesParts = [...state.projectsByCompaniesParts];
			if (projectsByCompaniesParts.includes(payload.part)) {
				return state;
			}
			projectsByCompaniesParts.push(payload.part);
			return {
				...state,
				projectsByCompanies: cleanDuplicates(
					[
						...state.projectsByCompanies, 
						...payload.data
					], 
					['CodProyecto', 'CodProyectoVector']
				),
				projectsByCompaniesLoading: projectsByCompaniesParts.length !== payload.count,
				projectsByCompaniesParts,
			};
		case CF_PROJECTS_BY_COMPANY_RESET:
			return {
				...state,
				projectsByCompanies: [],
				projectsByCompaniesLoading: false,
				projectsByCompaniesParts: [],
			};

		case CF_CASH_FLOW:
			const cashFlowDataParts = [...state.cashFlowDataParts];
			console.log('part', payload.part, 'lenght', payload.data.length)
			if (cashFlowDataParts.includes(payload.part)) {
				return state;
			}
			cashFlowDataParts.push(payload.part);
			return {
				...state,
				cashFlowData: orderByPeriods(cleanDuplicates(
					[
						...state.cashFlowData, 
						...payload.data
					], 
					'Periodo'
				)),
				cashFlowDataLoading: cashFlowDataParts.length !== payload.count,
				cashFlowDataParts,
			};
		case CF_CASH_FLOW_RESET:
			return {
				...state,
				cashFlowData: [],
				cashFlowDataLoading: false,
				cashFlowDataParts: [],
			};
		case CF_CASH_STRUCTURE:
			return {
				...state,
				cashFlowEstructure: payload?.data || [],
			};
		case CF_CASH_PCG_ITEMS:
			return {
				...state,
				cashFlowPcgItemsResume: payload.data.map(i => ({
					...i,
					id: i.CodPCG,
					description: i.DesPCG,
				})).filter(i => !!i.description),
			};
		case CF_CASH_RUBRO_ITEMS:
			return {
				...state,
				cashFlowPcgItemsResume: payload.data.map(i => ({
					...i,
					id: i.CodRubro,
					description: i.DesRubro,
				})).filter(i => !!i.description),
			};
		case CF_CASH_CDT_ITEMS:
			return {
				...state,
				cashFlowPcgItemsResume: payload.data.map(i => ({
					...i,
					id: i.CodCTD,
					description: i.DesCTD,
				})).filter(i => !!i.description),
			};
		case CF_CASH_RESOURCE_ITEMS:
			return {
				...state,
				cashFlowPcgItemsResume: cleanDuplicates(
					[
						...state.cashFlowPcgItemsResume, 
						...payload.data.map(i => ({
							...i,
							id: i.CodRecurso,
							description: i.DesRecurso,
						})),
					], 
					'id'
				).filter(i => !!i.description),
			};

		case CF_CASH_PCG_ITEMS_RESET:
			return {
				...state,
				cashFlowPcgItemsResume: [],
			};
		case CF_CASH_FLOW_GET_USER_FILTERS:
			return {
				...state,
				userFilters: payload.data.length ? payload.data[0] : null,
			};
		case CF_CASH_FLOW_SAVE_USER_FILTERS:
			return {
				...state,
				userFilters: payload,
			};

		default:
			return state;
	}
};
